export const library = [
    {
        id: 1,
        name: 'aries',
        date: 'Mar 21 - Apr 20',
        image: './img/logo/Aries.webp'
    },
    {
        id: 2,
        name: 'taurus',
        date: 'Apr 21 - May 21',
        image: './img/logo/Taurus.webp'
    },
    {
        id: 3,
        name: 'gemini',
        date: 'May 22 - Jun 21',
        image: './img/logo/Gemini.webp'
    },
    {
        id: 4,
        name: 'cancer',
        date: 'Jun 22 - Jul 22',
        image: './img/logo/Cancer.webp'
    },
    {
        id: 5,
        name: 'leo',
        date: 'Jul 23 - Aug 21',
        image: './img/logo/Leo.webp'
    },
    {
        id: 6,
        name: 'virgo',
        date: 'Aug  22 - Sep 23',
        image: './img/logo/Virgo.webp'
    },
    {
        id: 7,
        name: 'libra',
        date: 'Sep 24 - Oct 23',
        image: './img/logo/Libra.webp'
    },
    {
        id: 8,
        name: 'scorpio',
        date: 'Oct 24 - Nov 22',
        image: './img/logo/Scorpio.webp'
    },
    {
        id: 9,
        name: 'sagittarius',
        date: 'Nov 23 - Dec 22',
        image: './img/logo/Sagittarius.webp'
    },
    {
        id: 10,
        name: 'capricorn',
        date: 'Dec 23 - Jan 20',
        image: './img/logo/Capricorn.webp'
    },
    {
        id: 11,
        name: 'aquarius',
        date: 'Jan 21 - Feb 19',
        image: './img/logo/Aquarius.webp'
    },
    {
        id: 12,
        name: 'pisces',
        date: 'Feb 20 - Mar 20',
        image: './img/logo/Pisces.webp'
    },
]